import { useMemo } from 'react'

import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  MenuOutlined
} from '@ant-design/icons'
import { Dropdown, Tooltip } from 'antd'
import { ElementFormatType } from 'lexical'

import { BasicProps } from '@eastcoal/common/types/component'

import { useSelectionElementFormat } from '../../hooks/useSelectionElementFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { DropdownButton } from '../../ui/DropdownButton'

const items = [
  {
    key: 'left',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.TEXT_ALIGN_LEFT}>
        左对齐
      </Tooltip>
    ),
    icon: <AlignLeftOutlined />
  },
  {
    key: 'center',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.TEXT_ALIGN_CENTER}>
        居中对齐
      </Tooltip>
    ),
    icon: <AlignCenterOutlined />
  },
  {
    key: 'right',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.TEXT_ALIGN_RIGHT}>
        右对齐
      </Tooltip>
    ),
    icon: <AlignRightOutlined />
  },
  {
    key: 'justify',
    label: (
      <Tooltip placement='right' title={SHORTCUTS.TEXT_ALIGN_JUSTIFY}>
        两端对齐
      </Tooltip>
    ),
    icon: <MenuOutlined />
  }
]

export const TextAlignDropdown = (props: BasicProps) => {
  const [elementFormat, setElementFormat] = useSelectionElementFormat()
  const selectedItem = items.find(item => item.key === elementFormat)
  const selectedKeys = useMemo(() => [elementFormat], [elementFormat])
  return (
    <Dropdown
      menu={{
        items,
        selectedKeys,
        onClick: ({ key }) => {
          setElementFormat(key as ElementFormatType)
        }
      }}
    >
      <DropdownButton {...props} tooltip={selectedItem?.label}>
        {selectedItem?.icon}
      </DropdownButton>
    </Dropdown>
  )
}
